<div class="modal-header border">
  <h4 class="modal-title text-primary">Device assignment history</h4>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (assignments$ | async; as assignments;) {
    <div>
      @if (assignments?.length === 0) { There is no device assignment history available for this device. } @else {
        <p>Device id: {{ assignments[0]?.deviceId }}</p>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">Assigned at</th>
                <th scope="col">Location</th>
              </tr>
            </thead>
            <tbody>
              @for (assignment of assignments; track assignment) {
                <tr>
                  <td>{{ assignment?.user ?? "Unknown" }}</td>
                  <td>{{ assignment?.assignedAt | date }}</td>
                  <td>{{ getDisplayText(assignment) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>